export const WEBSITE_URL = process.env.REACT_APP_ENV === 'production' ?
    process.env.REACT_APP_PRODUCTION :
    process.env.REACT_APP_DEVELOPMENT;

export const homepage = () => {
    window.location.assign(WEBSITE_URL);
}

export const goToLinkWithNewTab = (link) => {
    window.open(link, "_blank");
}

export const goToMainPage = () => () => {
    window.location.assign(WEBSITE_URL);
}

export const goToLink = (link) => {
    window.location.assign(WEBSITE_URL+'/'+link);
}